import * as DropdownMenu from '@studio/design-system/dropdown-menu';
import { Icon } from '@studio/design-system/icon';
import { forwardRef, type ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ItemProps } from './types.js';

/** Toolbar `<Item>` component. */
export const Item = forwardRef<HTMLDivElement, ItemProps>(
  (
    { className, disabled, icon, selected, onSelect, showDropdown, ...props },
    ref
  ): ReactElement => (
    <div
      ref={ref}
      className={twMerge(
        showDropdown ? 'h-34 w-[44px] gap-x-4' : 'aspect-square h-34',
        'flex flex-row items-center justify-center',
        'transition-colors data-[enabled=true]:cursor-pointer data-[enabled=false]:opacity-disabled',
        'rounded data-[selected=true]:bg-primary data-[enabled=true]:hover:data-[selected=false]:bg-base-50',
        'data-[selected=true]:font-demibold data-[selected=false]:text-muted data-[selected=true]:text-light data-[enabled=true]:hover:data-[selected=false]:text-light',
        className
      )}
      data-enabled={!disabled ? 'true' : 'false'}
      data-selected={selected ? 'true' : 'false'}
      {...props}
    >
      <Icon className='text-xl' icon={icon} />
      {!!showDropdown && (
        <DropdownMenu.Trigger className='self-stretch transition-transform duration-[200ms] hover:translate-y-2'>
          <Icon className='text-xs' icon='chevron-down' />
        </DropdownMenu.Trigger>
      )}
    </div>
  )
);

Item.displayName = 'Item';
